export const LATITUDINE = "latitudine";
export const LONGITUDINE = "longitudine";
